import { Select } from '@mui/material';
import { BaseSelectProps } from './BaseSelect.types';

/**
 * The `BaseSelect` control that wraps the MUI `Select. We use this
 * to create separation between MUI and our wrappers for mocking with
 * jest.
 *
 * @param labelId - {@link BaseSelectProps.labelId labelId} description.
 * @param inputRef - {@link BaseSelectProps.inputRef inputRef} description.
 * @param name - {@link BaseSelectProps.name name} description.
 * @param classes - {@link BaseSelectProps.classes classes} description.
 * @param value - {@link BaseSelectProps.value value} description.
 * @param onFocus - {@link BaseSelectProps.onFocus onFocus} description.
 * @param onChange - {@link BaseSelectProps.onChange onChange} description.
 * @param onBlur - {@link BaseSelectProps.onBlur onBlur} description.
 * @param error - {@link BaseSelectProps.error error} description.
 * @param open - {@link BaseSelectProps.open open} description.
 * @param onOpen - {@link BaseSelectProps.onOpen onOpen} description.
 * @param onClose - {@link BaseSelectProps.onClose onClose} description.
 * @param IconComponent - {@link BaseSelectProps.IconComponent IconComponent} description.
 * @param children - {@link BaseSelectProps.children children} description.
 */
export const BaseSelect = ({
    labelId,
    inputRef,
    name,
    classes,
    value,
    onFocus,
    onChange,
    onBlur,
    error,
    open,
    onOpen,
    onClose,
    IconComponent,
    children,
}: BaseSelectProps) => {
    return (
        <Select
            labelId={labelId}
            name={name}
            variant={'standard'}
            inputRef={inputRef}
            classes={{
                ...classes,
            }}
            value={value}
            onFocus={onFocus}
            onChange={onChange}
            onBlur={onBlur}
            onOpen={onOpen}
            onClose={onClose}
            error={error}
            open={open}
            IconComponent={IconComponent}
            fullWidth
        >
            {children}
        </Select>
    );
};